module.exports = __webpack_public_path__ + "img/115.physical_conditions.1bb10522.svg";